import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { EBillContainer } from '@ruby/modules/ebill/containers/ebill.container';

const routes: Routes = [
  {
    path: '',
    component: EBillContainer,
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('@ruby/modules/ebill/submodules/ebill-dashboard/ebill-dashboard.module').then(m => m.EBillDashboardModule)
      },
      {
        path: 'details',
        loadChildren: () => import('@ruby/modules/ebill/submodules/ebill-details/ebill-details.module').then(m => m.EBillDetailsModule)
      },
      {
        path: 'delivery',
        loadChildren: () => import('@ruby/modules/ebill/submodules/ebill-manage/ebill-manage.module').then(m => m.EBillManageModule),
        data: { name: 'DELIVERY' }
      },
      {
        path: 'manage',
        loadChildren: () => import('@ruby/modules/ebill/submodules/ebill-manage/ebill-manage.module').then(m => m.EBillManageModule),
        data: { name: 'MANAGE' }
      },
      {
        path: 'profiles',
        loadChildren: () => import('@ruby/modules/ebill/submodules/ebill-manage/ebill-manage.module').then(m => m.EBillManageModule),
        data: { name: 'PROFILES' }
      },
      {
        path: 'dispute',
        loadChildren: () => import('@ruby/modules/ebill/submodules/ebill-dispute/ebill-dispute.module').then(m => m.EBillDisputeModule)
      },
      {
        path: 'locations',
        loadChildren: () => import('@ruby/modules/ebill/submodules/ebill-location/ebill-location.module').then(m => m.EBillLocationModule)
      },
      {
        path: 'car-dispute',
        loadChildren: () => import('@ruby/modules/ebill/submodules/ebill-car-dispute/ebill-car-dispute.module').then(m => m.EBillCarDisputeModule)
      },
      {
        path: 'demurrage',
        loadChildren: () => import('@ruby/modules/ebill/submodules/ebill-demurrage/ebill-demurrage.module').then(m => m.EBillDemurrageModule)
      },
      {
        path: 'finance',
        loadChildren: () => import('@ruby/modules/ebill/submodules/ebill-finance/ebill-finance.modules').then(m => m.EBillFinanceModules)
      },
      {
        path: 'tbt-details',
        loadChildren: () => import('@ruby/modules/ebill/submodules/ebill-tbt-toc/ebill-tbt-toc.module').then(m => m.EBillTbtTocModule)
      },
      {
        path: 'tbt-misc-details',
        loadChildren: () => import('@ruby/modules/ebill/submodules/ebill-tbt-misc/ebill-tbt-misc.module').then(m => m.EbillTbtMiscModule)
      },
      { path: '**', redirectTo: 'dashboard', pathMatch: 'full' }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EBillRoutingModule {}
